import { completeTask } from 'wisestep-api';

import { failed, success } from '../../../utils/NotificationMessages';

export const taskList = [
  {
    tabName: 'My Reminders',
  },
  {
    tabName: 'Team Reminders',
  },
];

export const closeTask = async (taskId: string) => {
  try {
    await completeTask(taskId);
    return success('Good Job');
  } catch {
    return failed('Something went wrong !!');
  }
};
